export type IconProps = React.ComponentProps<'svg'> & {
	color?: string
}

export const ZapIcon: React.FC<IconProps> = ({
	color = 'currentColor',
	...props
}) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M13.3982 1.08275C13.8054 1.25952 14.0474 1.68359 13.9923 2.12409L13.1328 9.00006H21C21.388 9.00006 21.741 9.22452 21.9056 9.5759C22.0702 9.92729 22.0166 10.3422 21.7682 10.6402L11.7682 22.6402C11.484 22.9813 11.009 23.0941 10.6018 22.9174C10.1946 22.7406 9.95267 22.3165 10.0077 21.876L10.8672 15.0001H3.00001C2.61199 15.0001 2.259 14.7756 2.09442 14.4242C1.92984 14.0728 1.98339 13.658 2.23179 13.3599L12.2318 1.35987C12.516 1.01884 12.991 0.905986 13.3982 1.08275ZM5.13505 13.0001H12C12.2868 13.0001 12.5599 13.1232 12.7497 13.3383C12.9395 13.5533 13.0279 13.8395 12.9923 14.1241L12.4154 18.7396L18.865 11.0001H12C11.7132 11.0001 11.4402 10.8769 11.2503 10.6619C11.0605 10.4468 10.9722 10.1606 11.0077 9.87602L11.5847 5.26051L5.13505 13.0001Z"
				fill={color}
			/>
		</svg>
	)
}

export const ReceiptIcon: React.FC<IconProps> = ({
	color = 'currentColor',
	...props
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="18"
			height="22"
			viewBox="0 0 18 22"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.474269 0.14935C0.769085 -0.0328564 1.13723 -0.0494204 1.44721 0.105574L3 0.881967L4.55279 0.105574C4.83431 -0.0351899 5.16569 -0.0351899 5.44721 0.105574L7 0.881967L8.55279 0.105574C8.83431 -0.0351899 9.16569 -0.0351899 9.44721 0.105574L11 0.881967L12.5528 0.105574C12.8343 -0.0351899 13.1657 -0.0351899 13.4472 0.105574L15 0.881967L16.5528 0.105574C16.8628 -0.0494204 17.2309 -0.0328564 17.5257 0.14935C17.8205 0.331557 18 0.653423 18 1V21C18 21.3466 17.8205 21.6684 17.5257 21.8507C17.2309 22.0329 16.8628 22.0494 16.5528 21.8944L15 21.118L13.4472 21.8944C13.1657 22.0352 12.8343 22.0352 12.5528 21.8944L11 21.118L9.44721 21.8944C9.16569 22.0352 8.83431 22.0352 8.55279 21.8944L7 21.118L5.44721 21.8944C5.16569 22.0352 4.83431 22.0352 4.55279 21.8944L3 21.118L1.44721 21.8944C1.13723 22.0494 0.769085 22.0329 0.474269 21.8507C0.179452 21.6684 0 21.3466 0 21V1C0 0.653423 0.179452 0.331557 0.474269 0.14935ZM2 2.61804V19.382L2.55279 19.1056C2.83431 18.9648 3.16569 18.9648 3.44721 19.1056L5 19.882L6.55279 19.1056C6.83431 18.9648 7.16569 18.9648 7.44721 19.1056L9 19.882L10.5528 19.1056C10.8343 18.9648 11.1657 18.9648 11.4472 19.1056L13 19.882L14.5528 19.1056C14.8343 18.9648 15.1657 18.9648 15.4472 19.1056L16 19.382V2.61803L15.4472 2.89443C15.1657 3.03519 14.8343 3.03519 14.5528 2.89443L13 2.11803L11.4472 2.89443C11.1657 3.03519 10.8343 3.03519 10.5528 2.89443L9 2.11803L7.44721 2.89443C7.16569 3.03519 6.83431 3.03519 6.55279 2.89443L5 2.11804L3.44721 2.89443C3.16569 3.03519 2.83431 3.03519 2.55279 2.89443L2 2.61804Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.87868 6.87868C5.44129 6.31607 6.20435 6 7 6H13C13.5523 6 14 6.44772 14 7C14 7.55228 13.5523 8 13 8H7C6.73478 8 6.48043 8.10536 6.29289 8.29289C6.10536 8.48043 6 8.73478 6 9C6 9.26522 6.10536 9.51957 6.29289 9.70711C6.48043 9.89464 6.73478 10 7 10H11C11.7957 10 12.5587 10.3161 13.1213 10.8787C13.6839 11.4413 14 12.2043 14 13C14 13.7957 13.6839 14.5587 13.1213 15.1213C12.5587 15.6839 11.7957 16 11 16H5C4.44772 16 4 15.5523 4 15C4 14.4477 4.44772 14 5 14H11C11.2652 14 11.5196 13.8946 11.7071 13.7071C11.8946 13.5196 12 13.2652 12 13C12 12.7348 11.8946 12.4804 11.7071 12.2929C11.5196 12.1054 11.2652 12 11 12H7C6.20435 12 5.44129 11.6839 4.87868 11.1213C4.31607 10.5587 4 9.79565 4 9C4 8.20435 4.31607 7.44129 4.87868 6.87868Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M9 5C9.55229 5 10 5.44772 10 6V16C10 16.5523 9.55229 17 9 17C8.44771 17 8 16.5523 8 16V6C8 5.44772 8.44771 5 9 5Z"
				fill={color}
			/>
		</svg>
	)
}

export const ShieldCheckIcon: React.FC<IconProps> = ({
	color = 'currentColor',
	...props
}) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.6489 1.06367C11.8753 0.978776 12.1247 0.978776 12.3511 1.06367L20.3511 4.06367C20.7414 4.21003 21 4.58316 21 5V12C21 15.4464 18.7183 18.2003 16.6585 20.0026C15.6076 20.9221 14.5615 21.6408 13.78 22.1292C13.3882 22.3741 13.0603 22.5627 12.8281 22.6913C12.7119 22.7556 12.6194 22.805 12.5547 22.839C12.5223 22.856 12.4968 22.8692 12.4788 22.8784L12.4573 22.8894L12.4508 22.8926L12.4486 22.8937C12.4486 22.8937 12.4472 22.8944 12 22C11.5528 22.8944 11.5522 22.8941 11.5522 22.8941L11.5492 22.8926L11.5427 22.8894L11.5212 22.8784C11.5032 22.8692 11.4777 22.856 11.4453 22.839C11.3806 22.805 11.2881 22.7556 11.1719 22.6913C10.9397 22.5627 10.6118 22.3741 10.22 22.1292C9.43854 21.6408 8.39238 20.9221 7.3415 20.0026C5.28175 18.2003 3 15.4464 3 12V5C3 4.58316 3.25857 4.21003 3.64888 4.06367L11.6489 1.06367ZM12 22L11.5522 22.8941C11.8337 23.0349 12.1657 23.0352 12.4472 22.8944L12 22ZM12 20.8628C12.1916 20.7541 12.4367 20.6103 12.72 20.4333C13.4385 19.9842 14.3924 19.3279 15.3415 18.4974C17.2817 16.7997 19 14.5536 19 12V5.693L12 3.068L5 5.693V12C5 14.5536 6.71825 16.7997 8.6585 18.4974C9.60762 19.3279 10.5615 19.9842 11.28 20.4333C11.5633 20.6103 11.8084 20.7541 12 20.8628Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.7071 9.29289C16.0976 9.68342 16.0976 10.3166 15.7071 10.7071L11.7071 14.7071C11.3166 15.0976 10.6834 15.0976 10.2929 14.7071L8.29289 12.7071C7.90237 12.3166 7.90237 11.6834 8.29289 11.2929C8.68342 10.9024 9.31658 10.9024 9.70711 11.2929L11 12.5858L14.2929 9.29289C14.6834 8.90237 15.3166 8.90237 15.7071 9.29289Z"
				fill={color}
			/>
		</svg>
	)
}

export const BatteryFullIcon: React.FC<IconProps> = ({
	color = 'currentColor',
	...props
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4 8C3.44772 8 3 8.44772 3 9V15C3 15.5523 3.44772 16 4 16H16C16.5523 16 17 15.5523 17 15V9C17 8.44772 16.5523 8 16 8H4ZM1 9C1 7.34315 2.34315 6 4 6H16C17.6569 6 19 7.34315 19 9V15C19 16.6569 17.6569 18 16 18H4C2.34315 18 1 16.6569 1 15V9Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22 10C22.5523 10 23 10.4477 23 11V13C23 13.5523 22.5523 14 22 14C21.4477 14 21 13.5523 21 13V11C21 10.4477 21.4477 10 22 10Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6 10C6.55228 10 7 10.4477 7 11V13C7 13.5523 6.55228 14 6 14C5.44772 14 5 13.5523 5 13V11C5 10.4477 5.44772 10 6 10Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10 10C10.5523 10 11 10.4477 11 11V13C11 13.5523 10.5523 14 10 14C9.44771 14 9 13.5523 9 13V11C9 10.4477 9.44771 10 10 10Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 10C14.5523 10 15 10.4477 15 11V13C15 13.5523 14.5523 14 14 14C13.4477 14 13 13.5523 13 13V11C13 10.4477 13.4477 10 14 10Z"
				fill={color}
			/>
		</svg>
	)
}

export const TrendingUpIcon: React.FC<IconProps> = ({
	color = 'currentColor',
	...props
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M22.7071 6.29289C23.0976 6.68342 23.0976 7.31658 22.7071 7.70711L14.2071 16.2071C13.8166 16.5976 13.1834 16.5976 12.7929 16.2071L8.5 11.9142L2.70711 17.7071C2.31658 18.0976 1.68342 18.0976 1.29289 17.7071C0.902369 17.3166 0.902369 16.6834 1.29289 16.2929L7.79289 9.79289C8.18342 9.40237 8.81658 9.40237 9.20711 9.79289L13.5 14.0858L21.2929 6.29289C21.6834 5.90237 22.3166 5.90237 22.7071 6.29289Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15 7C15 6.44772 15.4477 6 16 6H22C22.5523 6 23 6.44772 23 7V13C23 13.5523 22.5523 14 22 14C21.4477 14 21 13.5523 21 13V8H16C15.4477 8 15 7.55228 15 7Z"
				fill={color}
			/>
		</svg>
	)
}

export const BugOffIcon: React.FC<IconProps> = ({
	color = 'currentColor',
	...props
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.30046 1.28541C7.69511 0.899064 8.32824 0.905799 8.71459 1.30046L9.95327 2.56578C10.3347 2.33862 10.7533 2.17531 11.1928 2.08476C11.9704 1.92457 12.778 1.99935 13.5128 2.2996C14.2477 2.59984 14.8767 3.11197 15.3196 3.77079C15.7625 4.42961 15.9993 5.20532 16 5.99918V7.13C16 7.68229 15.5523 8.13 15 8.13C14.4477 8.13 14 7.68229 14 7.13V6.00082C14 6.00066 14 6.00099 14 6.00082C13.9996 5.60407 13.8812 5.2159 13.6598 4.88663C13.4383 4.55722 13.1239 4.30116 12.7564 4.15104C12.389 4.00091 11.9852 3.96352 11.5964 4.04362C11.2076 4.12372 10.8515 4.31768 10.5733 4.60083C10.3851 4.79242 10.1277 4.90024 9.8591 4.9C9.59051 4.89976 9.33331 4.79148 9.14541 4.59955L7.28541 2.69955C6.89906 2.30489 6.9058 1.67176 7.30046 1.28541Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M16.7072 1.29289C17.0977 1.68342 17.0977 2.31658 16.7072 2.70711L14.8272 4.58711C14.4367 4.97763 13.8035 4.97763 13.413 4.58711C13.0225 4.19658 13.0225 3.56342 13.413 3.17289L15.293 1.29289C15.6835 0.902369 16.3167 0.902369 16.7072 1.29289Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.7 7C11.7 6.44772 12.1477 6 12.7 6L14 6.00082C15.3261 6.00082 16.5978 6.52678 17.5355 7.46447C18.4732 8.40215 19 9.67392 19 11V12H22C22.5522 12 23 12.4477 23 13C23 13.5523 22.5522 14 22 14H18C17.4477 14 17 13.5523 17 13V11C17 10.2044 16.6839 9.44129 16.1213 8.87868C15.5587 8.31607 14.7956 8 14 8H12.7C12.1477 8 11.7 7.55228 11.7 7Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M20.9701 4C21.5223 4 21.9701 4.44772 21.9701 5C21.9701 7.60626 19.9891 9.74036 17.5747 9.99451C17.0255 10.0523 16.5334 9.65393 16.4755 9.10468C16.4177 8.55543 16.8161 8.06331 17.3654 8.00549C18.751 7.85964 19.9701 6.59374 19.9701 5C19.9701 4.44772 20.4178 4 20.9701 4Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1.29289 1.29289C1.68342 0.902369 2.31658 0.902369 2.70711 1.29289L22.7071 21.2929C23.0976 21.6834 23.0976 22.3166 22.7071 22.7071C22.3166 23.0976 21.6834 23.0976 21.2929 22.7071L1.29289 2.70711C0.902369 2.31658 0.902369 1.68342 1.29289 1.29289Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.51826 7.125C8.83581 7.57686 8.72693 8.20059 8.27507 8.51814C7.87836 8.79694 7.55513 9.16774 7.33308 9.59878C7.11102 10.0298 6.99676 10.5083 7.00007 10.9931L7.00012 11L7.00009 14.003C6.99676 15.0957 7.35148 16.1594 8.01 17.0314C8.66851 17.9035 9.59455 18.5357 10.6465 18.8315C11.6984 19.1274 12.8182 19.0704 13.8347 18.6695C14.8512 18.2685 15.7084 17.5456 16.2751 16.6114C16.5615 16.1391 17.1765 15.9885 17.6487 16.275C18.1209 16.5614 18.2715 17.1764 17.9851 17.6486C17.1917 18.9566 15.9917 19.9687 14.5686 20.53C13.1455 21.0913 11.5777 21.171 10.105 20.7569C8.63235 20.3427 7.33589 19.4575 6.41397 18.2367C5.49237 17.0163 4.99578 15.5278 5.00009 13.9985V11.0032C4.99516 10.1963 5.18559 9.40021 5.55513 8.68287C5.92522 7.96446 6.46393 7.34646 7.12512 6.8818C7.57698 6.56425 8.20071 6.67313 8.51826 7.125Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 11C12.5523 11 13 11.4477 13 12V20C13 20.5523 12.5523 21 12 21C11.4477 21 11 20.5523 11 20V12C11 11.4477 11.4477 11 12 11Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1 13C1 12.4477 1.44772 12 2 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H2C1.44772 14 1 13.5523 1 13Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M7.79887 16.9525C7.82514 17.5041 7.39923 17.9726 6.84757 17.9989C5.28581 18.0733 4 19.4287 4 21C4 21.5523 3.55228 22 3 22C2.44772 22 2 21.5523 2 21C2 18.3713 4.11419 16.1268 6.75243 16.0012C7.30409 15.9749 7.7726 16.4008 7.79887 16.9525Z"
				fill={color}
			/>
		</svg>
	)
}

export const GaugeCircleIcon: React.FC<IconProps> = ({
	color = 'currentColor',
	...props
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8.61099 1.54963C11.0138 0.776937 13.6093 0.854063 15.9619 1.76807C16.4767 1.96807 16.7319 2.54753 16.5319 3.06233C16.3319 3.57713 15.7525 3.83233 15.2377 3.63233C13.3128 2.8845 11.1892 2.8214 9.22327 3.45361C7.25733 4.08581 5.56861 5.37487 4.44039 7.10453C3.31218 8.83419 2.8131 10.8992 3.02689 12.9532C3.24068 15.0072 4.15433 16.9252 5.61457 18.3854C7.07481 19.8457 8.9928 20.7593 11.0468 20.9731C13.1008 21.1869 15.1658 20.6878 16.8955 19.5596C18.6251 18.4314 19.9142 16.7427 20.5464 14.7767C21.1786 12.8108 21.1155 10.6873 20.3677 8.76233C20.1677 8.24753 20.4229 7.66807 20.9377 7.46807C21.4525 7.26808 22.0319 7.52327 22.2319 8.03807C23.146 10.3908 23.2231 12.9862 22.4504 15.389C21.6777 17.7918 20.1022 19.8558 17.9881 21.2348C15.8741 22.6137 13.3502 23.2237 10.8397 22.9624C8.32931 22.7011 5.9851 21.5844 4.20036 19.7997C2.41562 18.0149 1.29894 15.6707 1.03764 13.1603C0.776339 10.6498 1.38632 8.1259 2.76525 6.01187C4.14418 3.89785 6.20818 2.32233 8.61099 1.54963Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.9998 11.0002C11.4475 11.0002 10.9998 11.4479 10.9998 12.0002C10.9998 12.5525 11.4475 13.0002 11.9998 13.0002C12.552 13.0002 12.9998 12.5525 12.9998 12.0002C12.9998 11.4479 12.552 11.0002 11.9998 11.0002ZM8.99976 12.0002C8.99976 10.3433 10.3429 9.0002 11.9998 9.0002C13.6566 9.0002 14.9998 10.3433 14.9998 12.0002C14.9998 13.6571 13.6566 15.0002 11.9998 15.0002C10.3429 15.0002 8.99976 13.6571 8.99976 12.0002Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M19.7068 4.29309C20.0973 4.68362 20.0973 5.31678 19.7068 5.70731L14.1068 11.3073C13.7162 11.6978 13.0831 11.6978 12.6926 11.3073C12.302 10.9168 12.302 10.2836 12.6926 9.89309L18.2926 4.29309C18.6831 3.90257 19.3162 3.90257 19.7068 4.29309Z"
				fill={color}
			/>
		</svg>
	)
}

export const NetworkIcon: React.FC<IconProps> = ({
	color = 'currentColor',
	...props
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15 17C15 15.8954 15.8954 15 17 15H21C22.1046 15 23 15.8954 23 17V21C23 22.1046 22.1046 23 21 23H17C15.8954 23 15 22.1046 15 21V17ZM21 17H17V21H21V17Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M1 17C1 15.8954 1.89543 15 3 15H7C8.10457 15 9 15.8954 9 17V21C9 22.1046 8.10457 23 7 23H3C1.89543 23 1 22.1046 1 21V17ZM7 17H3V21H7V17Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 3C8 1.89543 8.89543 1 10 1H14C15.1046 1 16 1.89543 16 3V7C16 8.10457 15.1046 9 14 9H10C8.89543 9 8 8.10457 8 7V3ZM14 3H10V7H14V3Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M4.58579 11.5858C4.96086 11.2107 5.46957 11 6 11H18C18.5304 11 19.0391 11.2107 19.4142 11.5858C19.7893 11.9609 20 12.4696 20 13V16C20 16.5523 19.5523 17 19 17C18.4477 17 18 16.5523 18 16V13H6V16C6 16.5523 5.55228 17 5 17C4.44772 17 4 16.5523 4 16V13C4 12.4696 4.21071 11.9609 4.58579 11.5858Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V8C11 7.44772 11.4477 7 12 7Z"
				fill={color}
			/>
		</svg>
	)
}

export const ShieldAlertIcon: React.FC<IconProps> = ({
	color = 'currentColor',
	...props
}) => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11.6489 1.06367C11.8753 0.978776 12.1247 0.978776 12.3511 1.06367L20.3511 4.06367C20.7414 4.21003 21 4.58316 21 5V12C21 15.4464 18.7183 18.2003 16.6585 20.0026C15.6076 20.9221 14.5615 21.6408 13.78 22.1292C13.3882 22.3741 13.0603 22.5627 12.8281 22.6913C12.7119 22.7556 12.6194 22.805 12.5547 22.839C12.5223 22.856 12.4968 22.8692 12.4788 22.8784L12.4573 22.8894L12.4508 22.8926L12.4486 22.8937C12.4486 22.8937 12.4472 22.8944 12 22C11.5528 22.8944 11.5522 22.8941 11.5522 22.8941L11.5492 22.8926L11.5427 22.8894L11.5212 22.8784C11.5032 22.8692 11.4777 22.856 11.4453 22.839C11.3806 22.805 11.2881 22.7556 11.1719 22.6913C10.9397 22.5627 10.6118 22.3741 10.22 22.1292C9.43854 21.6408 8.39238 20.9221 7.3415 20.0026C5.28175 18.2003 3 15.4464 3 12V5C3 4.58316 3.25857 4.21003 3.64888 4.06367L11.6489 1.06367ZM12 22L11.5522 22.8941C11.8337 23.0349 12.1657 23.0352 12.4472 22.8944L12 22ZM12 20.8628C12.1916 20.7541 12.4367 20.6103 12.72 20.4333C13.4385 19.9842 14.3924 19.3279 15.3415 18.4974C17.2817 16.7997 19 14.5536 19 12V5.693L12 3.068L5 5.693V12C5 14.5536 6.71825 16.7997 8.6585 18.4974C9.60762 19.3279 10.5615 19.9842 11.28 20.4333C11.5633 20.6103 11.8084 20.7541 12 20.8628Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M12 7C12.5523 7 13 7.44772 13 8V12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12V8C11 7.44772 11.4477 7 12 7Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M11 16C11 15.4477 11.4477 15 12 15H12.01C12.5623 15 13.01 15.4477 13.01 16C13.01 16.5523 12.5623 17 12.01 17H12C11.4477 17 11 16.5523 11 16Z"
				fill={color}
			/>
		</svg>
	)
}

export const ViewIcon: React.FC<IconProps> = ({
	color = 'currentColor',
	...props
}) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M6.15453 12C6.19861 12.0709 6.24807 12.1486 6.30283 12.2319C6.58717 12.6643 7.00791 13.2387 7.55275 13.8095C8.65935 14.9689 10.165 16 12 16C13.8345 16 15.3401 14.9689 16.4469 13.8095C16.9918 13.2387 17.4127 12.6642 17.6971 12.2318C17.7518 12.1485 17.8013 12.0709 17.8454 12C17.8013 11.9291 17.7518 11.8515 17.6971 11.7682C17.4127 11.3358 16.9918 10.7613 16.4469 10.1905C15.3401 9.03106 13.8345 8 12 8C10.165 8 8.65935 9.0311 7.55275 10.1905C7.00791 10.7613 6.58717 11.3357 6.30283 11.7681C6.24807 11.8514 6.19861 11.9291 6.15453 12ZM19 12C19.8911 11.5462 19.8908 11.5456 19.8908 11.5456L19.8894 11.5429L19.8867 11.5376L19.8785 11.5218C19.8717 11.5089 19.8624 11.4914 19.8506 11.4695C19.827 11.4256 19.7933 11.3644 19.7496 11.2881C19.6623 11.1357 19.5348 10.9227 19.3681 10.6693C19.036 10.1642 18.5419 9.48868 17.8936 8.8095C16.6139 7.46894 14.6195 6 12 6C9.38004 6 7.38565 7.4689 6.106 8.80954C5.45771 9.48874 4.96377 10.1643 4.6317 10.6694C4.46505 10.9228 4.33754 11.1358 4.25027 11.2882C4.20659 11.3645 4.17289 11.4258 4.14929 11.4696C4.13748 11.4915 4.1282 11.5091 4.12145 11.522L4.11322 11.5378L4.11054 11.543L4.10955 11.5449C4.10955 11.5449 4.1088 11.5464 5 12L4.1088 11.5464C3.96373 11.8314 3.96373 12.1686 4.1088 12.4536L5 12C4.1088 12.4536 4.1088 12.4536 4.1088 12.4536L4.10955 12.4551L4.11054 12.457L4.11322 12.4622L4.12145 12.478C4.1282 12.4909 4.13748 12.5085 4.14929 12.5304C4.17289 12.5742 4.20659 12.6355 4.25027 12.7118C4.33754 12.8642 4.46505 13.0772 4.6317 13.3306C4.96377 13.8357 5.45771 14.5113 6.106 15.1905C7.38565 16.5311 9.38004 18 12 18C14.6195 18 16.6139 16.5311 17.8936 15.1905C18.5419 14.5113 19.036 13.8358 19.3681 13.3307C19.5348 13.0773 19.6623 12.8643 19.7496 12.7119C19.7933 12.6356 19.827 12.5744 19.8506 12.5305C19.8624 12.5086 19.8717 12.4911 19.8785 12.4782L19.8867 12.4624L19.8894 12.4571L19.8904 12.4552C19.8904 12.4552 19.8911 12.4538 19 12ZM19 12L19.8911 12.4538C20.0363 12.1687 20.0359 11.8307 19.8908 11.5456L19 12Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M10.5858 10.5858C10.9609 10.2107 11.4696 10 12 10C12.5304 10 13.0391 10.2107 13.4142 10.5858C13.7893 10.9609 14 11.4696 14 12C14 12.5304 13.7893 13.0391 13.4142 13.4142C13.0391 13.7893 12.5304 14 12 14C11.4696 14 10.9609 13.7893 10.5858 13.4142C10.2107 13.0391 10 12.5304 10 12C10 11.4696 10.2107 10.9609 10.5858 10.5858Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3 16C3.55228 16 4 16.4477 4 17V19C4 19.2652 4.10536 19.5196 4.29289 19.7071C4.48043 19.8946 4.73478 20 5 20H19C19.2652 20 19.5196 19.8946 19.7071 19.7071C19.8946 19.5196 20 19.2652 20 19V17C20 16.4477 20.4477 16 21 16C21.5523 16 22 16.4477 22 17V19C22 19.7957 21.6839 20.5587 21.1213 21.1213C20.5587 21.6839 19.7957 22 19 22H5C4.20435 22 3.44129 21.6839 2.87868 21.1213C2.31607 20.5587 2 19.7957 2 19V17C2 16.4477 2.44772 16 3 16Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M2.87868 2.87868C3.44129 2.31607 4.20435 2 5 2H19C19.7957 2 20.5587 2.31607 21.1213 2.87868C21.6839 3.44129 22 4.20435 22 5V7C22 7.55228 21.5523 8 21 8C20.4477 8 20 7.55228 20 7V5C20 4.73478 19.8946 4.48043 19.7071 4.29289C19.5196 4.10536 19.2652 4 19 4H5C4.73478 4 4.48043 4.10536 4.29289 4.29289C4.10536 4.48043 4 4.73478 4 5V7C4 7.55228 3.55228 8 3 8C2.44772 8 2 7.55228 2 7V5C2 4.20435 2.31607 3.44129 2.87868 2.87868Z"
				fill={color}
			/>
		</svg>
	)
}

export const FileCheckIcon: React.FC<IconProps> = ({
	color = 'currentColor',
	...props
}) => {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M3.87868 1.87868C4.44129 1.31607 5.20435 1 6 1H14.5C14.7652 1 15.0196 1.10536 15.2071 1.29289L20.7071 6.79289C20.8946 6.98043 21 7.23478 21 7.5V20C21 20.7957 20.6839 21.5587 20.1213 22.1213C19.5587 22.6839 18.7957 23 18 23H6C5.20435 23 4.44129 22.6839 3.87868 22.1213C3.31607 21.5587 3 20.7957 3 20V4C3 3.20435 3.31607 2.44129 3.87868 1.87868ZM6 3C5.73478 3 5.48043 3.10536 5.29289 3.29289C5.10536 3.48043 5 3.73478 5 4V20C5 20.2652 5.10536 20.5196 5.29289 20.7071C5.48043 20.8946 5.73478 21 6 21H18C18.2652 21 18.5196 20.8946 18.7071 20.7071C18.8946 20.5196 19 20.2652 19 20V7.91421L14.0858 3H6Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 1C14.5523 1 15 1.44772 15 2V7H20C20.5523 7 21 7.44772 21 8C21 8.55228 20.5523 9 20 9H14C13.4477 9 13 8.55228 13 8V2C13 1.44772 13.4477 1 14 1Z"
				fill={color}
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M15.7071 12.2929C16.0976 12.6834 16.0976 13.3166 15.7071 13.7071L11.7071 17.7071C11.3166 18.0976 10.6834 18.0976 10.2929 17.7071L8.29289 15.7071C7.90237 15.3166 7.90237 14.6834 8.29289 14.2929C8.68342 13.9024 9.31658 13.9024 9.70711 14.2929L11 15.5858L14.2929 12.2929C14.6834 11.9024 15.3166 11.9024 15.7071 12.2929Z"
				fill={color}
			/>
		</svg>
	)
}
